import * as THREE from 'three';

// Closed surfaces built from designed cross-sections, rather than stacked solids.
// Rings ascend in Y. rx/rz are half extents; power < 1 gives broad facial/cloth planes.
export function profile(rings, { segments = 12, power = 0.8, caps = 'both' } = {}) {
  const positions = [], indices = [];
  for (const r of rings) for (let i = 0; i < segments; i++) {
    const a = i * Math.PI * 2 / segments, s = Math.sin(a), c = Math.cos(a);
    const ringPower = r.power ?? power;
    positions.push((r.x || 0) + r.rx * Math.sign(s) * Math.abs(s) ** ringPower,
      r.y, (r.z || 0) + r.rz * Math.sign(c) * Math.abs(c) ** ringPower);
  }
  for (let row = 0; row < rings.length - 1; row++) for (let i = 0; i < segments; i++) {
    const a = row * segments + i, b = row * segments + (i + 1) % segments;
    indices.push(a, b, a + segments, b, b + segments, a + segments);
  }
  // Separate cap vertices preserve the seam normal without flattening the sides.
  for (const row of [0, rings.length - 1]) {
    if (caps === 'none' || (caps === 'top' && row === 0) || (caps === 'bottom' && row !== 0)) continue;
    const r = rings[row], center = positions.length / 3;
    positions.push(r.x || 0, r.y, r.z || 0);
    const start = positions.length / 3;
    positions.push(...positions.slice(row * segments * 3, (row + 1) * segments * 3));
    for (let i = 0; i < segments; i++) {
      const a = start + i, b = start + (i + 1) % segments;
      indices.push(center, row === 0 ? b : a, row === 0 ? a : b);
    }
  }
  const geo = new THREE.BufferGeometry();
  geo.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));
  geo.setIndex(indices);
  geo.computeVertexNormals();
  return geo;
}

export function sampleProfile(rings, y) {
  if (y <= rings[0].y) return rings[0];
  for (let i = 1; i < rings.length; i++) if (y <= rings[i].y) {
    const a = rings[i - 1], b = rings[i], t = (y - a.y) / (b.y - a.y);
    return { y, rx: THREE.MathUtils.lerp(a.rx, b.rx, t), rz: THREE.MathUtils.lerp(a.rz, b.rz, t),
      z: THREE.MathUtils.lerp(a.z || 0, b.z || 0, t) };
  }
  return rings.at(-1);
}
